<template>
  <div
    class="goal-content temperature-goal page-card-wrapper"
    :class="wrapperClassObject"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.desire_temperature')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-30 page-content">
        <div class="slider-title mb-30">
          {{ $t('text.acceptable_temperature_range').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100">
          <span
            v-if="value[0] !== min"
            class="value-text"
            :style="{ left: (value[0] - min) / ((this.max - min) / 100) + '%' }"
            >{{ value[0] }} {{ isCelsiusTempUnit ? '°C' : 'F' }}</span
          >
          <span
            v-if="value[1] !== min"
            class="value-text"
            :style="{ left: (value[1] - min) / ((this.max - min) / 100) + '%' }"
            >{{ value[1] }} {{ isCelsiusTempUnit ? '°C' : 'F' }}</span
          >
          <el-slider
            range
            v-model="value"
            :min="min"
            :max="max"
            :marks="marks"
            :show-tooltip="false"
            @change="handleChangeSlider()"
          >
          </el-slider>
          <div class="min-value">{{ $t('text.off') }}</div>
          <div class="max-value">
            {{ max }} {{ isCelsiusTempUnit ? '°C' : 'F' }}
          </div>
        </div>
        <div class="warning-text">
          <span v-if="value[0] <= min">{{
            $t('text.temperature_alert_off')
          }}</span>
          <span v-else
            >{{ $t('text.temperature_alert_on') }} {{ $t('text.below') }}
            {{ value[0] }}{{ isCelsiusTempUnit ? '°C' : 'F' }}
            {{ $t('text.or') }} {{ $t('text.above') }} {{ value[1]
            }}{{ isCelsiusTempUnit ? '°C' : 'F' }}</span
          >
        </div>
        <div class="text-right mt-10">
          <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
            $t('text.default').toUpperCase()
          }}</b-button>
          <el-button
            type="success"
            plain
            class="common-btn"
            :loading="saveLoading"
            @click="save()"
            :disabled="saveLoading"
            v-if="p('Patients.Goals.Temperature.Add')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
        </div>
        <div class="setting-wrapper mt-40 mb-30">
          <div class="image-wrapper inline-block">
            <img src="@/assets/image/light.svg" />
          </div>
          <div class="inline-block">
            <div>
              <span class="w-140 inline-block"
                >{{ $t('text.typical_temp') }}:</span
              >
              <span
                >{{ patientData.TypicalTemp }}{{ patientData.TempUnit }}</span
              >
            </div>
            <div class="second-row">
              <span class="left-side">
                <span class="w-140 inline-block"
                  >{{ $t('text.temp_range') }}:</span
                >
                <span>{{ patientData.TempRange }}</span>
              </span>
              <span class="right-side">
                <span>{{ $t('text.last_7_day_period') }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      value: [24, 24],
      min: 24,
      max: 45,
      marks: {
        25: {
          style: {
            color: '#81D3F8',
            fontSize: '16px',
            marginTop: '25px',
            marginLeft: '10px'
          },
          label: this.$createElement('div', '25°C')
        }
      },
      lastValue: [24, 24],
      patientData: {},
      goal: {},
      saveLoading: false,
      isCelsiusTempUnit: true
    }
  },
  computed: {
    wrapperClassObject: function() {
      if (this.$store.state.locale.currentLocale === 'fr') return 'fr-wrapper'
      else if (this.$store.state.locale.currentLocale === 'it')
        return 'it-wrapper'
      else return ''
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.lastValue = oldVal
      },
      deep: true
    },
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    },
    '$store.state.patient.selectedPatientData': function() {
      this.getPatientData()
    },
    isCelsiusTempUnit: function() {
      // if is celsius unit, temperate range is 25 - 45, if F unit, temperature range is 60 - 120
      if (this.isCelsiusTempUnit) {
        this.value = [24, 24]
        this.min = 24
        this.max = 45
        this.marks = {
          25: {
            style: {
              color: '#81D3F8',
              fontSize: '16px',
              marginTop: '25px',
              marginLeft: '10px'
            },
            label: this.$createElement('div', '25°C')
          }
        }
        this.lastValue = [24, 24]
      } else {
        this.value = [59, 59]
        this.min = 59
        this.max = 120
        this.marks = {
          60: {
            style: {
              color: '#81D3F8',
              fontSize: '16px',
              marginTop: '25px',
              marginLeft: '10px'
            },
            label: this.$createElement('div', '60F')
          }
        }
        this.lastValue = [59, 59]
      }
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
    this.getInitVal()
    this.getPatientData()
  },
  methods: {
    getInitVal() {
      this.goal = this.$store.state.patient.selectedPatientGoal
      //if one slider is off, another shown as off too
      if (!this.goal.MinTemp || !this.goal.MaxTemp) {
        this.value = this.lastValue = [0, 0]
      } else {
        this.value = this.lastValue = [this.goal.MinTemp, this.goal.MaxTemp]
      }
      this.isCelsiusTempUnit = this.goal.TempUnit !== 'F'
    },
    getPatientData() {
      this.patientData = this.$store.state.patient.selectedPatientData
    },
    handleChangeSlider() {
      //When when one of the control slider is at at "OFF"  position, the the other control slider will snap to OFF as well.
      //When one of the control slider is >=25 C then the other slider will got to 45C automatically.
      //Other than that, the user can move both slider ends to be in range of 25 to 45C.
      if (this.lastValue[0] !== this.value[0]) {
        if (this.value[0] === this.min) {
          this.value = [this.min, this.min]
        }
        if (this.value[0] >= this.min + 1 && this.lastValue[1] === this.min) {
          this.value = [this.value[0], this.max]
        }
      } else {
        if (this.lastValue[1] !== this.value[1]) {
          if (this.value[1] === this.min) {
            this.value = [this.min, this.min]
          }
          if (this.value[1] >= this.min + 1 && this.lastValue[0] === this.min) {
            this.value = [this.max, this.value[1]]
          }
        }
      }
    },
    save() {
      if (!this.$store.state.patient.selectedPatient) return false
      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MinTemp:
          Math.min(...this.value) === this.min ? 0 : Math.min(...this.value),
        MaxTemp:
          Math.max(...this.value) === this.min ? 0 : Math.max(...this.value),
        TempUnit: this.goal.TempUnit || 'C'
      }
      this.saveLoading = true
      ApiService.SaveTemperatureGoal(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            this.$store.dispatch('patient/getSelectedPatientHistoryData')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fr-wrapper {
  &.goal-content {
    .slider-wrapper .min-value {
      left: -55px;
    }
  }
}
.it-wrapper {
  &.goal-content {
    .slider-wrapper .min-value {
      left: -30px;
    }
  }
}
@media (max-width: 1100px) and (min-width: 1024px) {
  .fr-wrapper {
    &.goal-content {
      .slider-wrapper .min-value {
        left: -10px;
        margin-top: 15px;
      }
    }
  }
  .it-wrapper {
    &.goal-content {
      .slider-wrapper .min-value {
        left: -10px;
        margin-top: 15px;
      }
    }
  }
}
@media (max-width: 900px) {
  .fr-wrapper {
    &.goal-content {
      .slider-wrapper .min-value {
        left: -10px;
        margin-top: 15px;
      }
    }
  }
  .it-wrapper {
    &.goal-content {
      .slider-wrapper .min-value {
        left: -10px;
        margin-top: 15px;
      }
    }
  }
}
</style>
